export default __webpack_public_path__ + "static/media/55-min.ec3d41a0.png";